import { KeyboardDoubleArrowDown } from "@mui/icons-material";
import { Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import { INTRO_ANCHOR_ID } from "@/app/features/shared/__to_be_integrated/ui/intro-anchor-id";
import styles from "@/app/features/sites/home/ui/public/home-public.module.css";

const arrowSize = 48;
export default function ScrollDownArrows({ label }: { label?: string }) {
    return (
        <a href={`#${INTRO_ANCHOR_ID}`} className={styles.scrollDownLink} aria-label="Weiter zum Inhalt">
            <Stack className="w-full justify-evenly items-center animate-pulse-opaque" direction="row">
                <KeyboardDoubleArrowDown sx={{ fontSize: arrowSize }} />
                <Typography className="relative uppercase" color="text.primary">
                    {label || "weiterscrollen und entdecken"}
                </Typography>
                <KeyboardDoubleArrowDown sx={{ fontSize: arrowSize }} />
            </Stack>
        </a>
    )
}
